import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipmentDetailsComponent } from './shipment-details.component';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {TableModule} from 'primeng/table';
import {ShipmentTrackingModule} from '../shipment-tracking/shipment-tracking.module';
import { ShipmentResponsiveCardComponent } from './shipment-responsive-card/shipment-responsive-card.component';
import {RippleModule} from 'primeng/ripple';
import {ToastModule} from "primeng/toast";
import {DropdownModule} from "primeng/dropdown";
import {FormsModule} from "@angular/forms";



@NgModule({
  declarations: [ShipmentDetailsComponent, ShipmentResponsiveCardComponent],
    imports: [
        CommonModule,
        BreadcrumbModule,
        TableModule,
        ShipmentTrackingModule,
        RippleModule,
        ToastModule,
        DropdownModule,
        FormsModule
    ]
})
export class ShipmentDetailsModule { }
